/* eslint-disable */

import React from "react";
import { Box, Flex, Spacer } from "@chakra-ui/react";
import { useTranslation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { getEnums } from "./../../../utils/store/actions/survey.action";
import { B4FNumber } from "./B4FNumber";
import { B4FSelect } from "./B4FSelect";

interface B4FCurrencyProps {
  label: string;
  id: string;
  value: string[];
  onBlur: any;
  onUpdate: any;
  onChange: any;
  visible: boolean;
  isRequired: any;
  disabled: boolean;
}

const B4FCurrency: React.FC<B4FCurrencyProps> = (props: any) => {
  const { t } = useTranslation();
  return (
    <>
      <Flex>
        <Box
          w="70%"
          style={{
            display: props.id.includes("amount") ? "flex" : "block",
            justifyContent: props.id.includes("amount") ? "center" : "inherit",
            alignItems: props.id.includes("amount") ? "center" : "inherit",
            marginTop: props.id.includes("amount") ? "13px" : "0",
          }}
        >
          <B4FNumber
            label={props.label}
            isDisabled={props.disabled}
            id={`${props.id}.value`}
            value={props.value[0]}
            onBlur={props.onBlur}
            onChange={props.onChange}
            visible={props.visible}
            isRequired={props.isRequired}
          />
        </Box>
        <Spacer />
        <Box
          w="25%"
          style={{
            display: props.id.includes("amount") ? "flex" : "block",
            justifyContent: props.id.includes("amount") ? "center" : "inherit",
            alignItems: props.id.includes("amount") ? "center" : "inherit",
            marginTop: props.id.includes("amount") ? "13px" : "23px",
          }}
        >
          {props.id !== "recommendedInvestmentPeriod" ? (
            <B4FSelect
              label={""}
              isDisabled={props.disabled}
              id={`${props.id}.currency`}
              value={props.value[1]}
              onBlur={props.onChange}
              onUpdate={props.onUpdate}
              onChange={props.onBlur}
              visible={props.visible}
              isRequired={props.isRequired}
              options={props.Surveys?.enums["currency-codes"]}
            />
          ) : (
            <B4FSelect
              label={""}
              isDisabled={props.disabled}
              id={`${props.id}.currency`}
              value={props.value[1]}
              onBlur={props.onChange}
              onUpdate={props.onUpdate}
              onChange={props.onBlur}
              visible={props.visible}
              isRequired={props.isRequired}
              options={[
                { label: "YEAR", key: "YEAR" },
                { label: "MONTH", key: "MONTH" },
              ]}
            />
          )}
        </Box>
      </Flex>
    </>
  );
};

const mapStateToProps = (state: { Surveys: SurveyState }) => ({
  Surveys: state.Surveys,
});

const mapDispatchToProps = {
  getEnums,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(B4FCurrency));
